var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{ref:"span",attrs:{"contenteditable":"true","placeholder":_vm.placeholder,"id":"editableSpan"},on:{"input":_vm.send}},[_vm._v(" "+_vm._s(_vm.inp)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }